import React from 'react'

import { Box, Paper } from '@material-ui/core'

import {
  BannerTitle,
  BannerDescription,
  BannerPortalRow,
  BannerActionButton,
} from '..'

import usePrimaryBannerPreview from 'hooks/usePrimaryBannerPreview'

import useStyles from './styles'

const FullBannerLayout = () => {
  const { hideRejectButton } = usePrimaryBannerPreview()

  const classes = useStyles()

  return (
    <Paper className={classes.paperContainer}>
      <Box className={classes.title}>
        <BannerTitle />
      </Box>
      <Box className={classes.textBlock}>
        <BannerDescription />
        <BannerPortalRow />
      </Box>
      <Box className={classes.fixedActions}>
        <BannerActionButton kind="settings" />
        {!hideRejectButton && <BannerActionButton kind="reject" />}
        <BannerActionButton kind="accept" />
      </Box>
    </Paper>
  )
}

export default FullBannerLayout
